import React from 'react'

import { InputLabel } from '@mui/material'

import { SelectInputProps } from '../../../ana-toolbox'
import { TextFieldLabel } from '../../utils/shared/TextFieldLabel'
import { FieldHelperText } from '../field-helper-text/field-helper-text'
import { Translate } from '../translate/translate'

import * as S from './select-input.styles'

export const SelectInput = ({
  value,
  onChange,
  onBlur,
  name,
  error,
  required,
  helperText,
  options = [],
  className,
  label,
}: SelectInputProps) => {
  return (
    <>
      <S.FormControl error={Boolean(error)} className={className} variant="outlined">
        <InputLabel id={`${name}-label`}>
          <TextFieldLabel required={required}>
            <Translate>{label}</Translate>
          </TextFieldLabel>
        </InputLabel>

        <S.Select
          id={`${name}-select`}
          labelId={`${name}-label`}
          name={name}
          value={value}
          label={<Translate>{label}</Translate>}
          error={Boolean(error)}
          MenuProps={{
            disablePortal: true,
            variant: 'menu',
            anchorPosition: {
              top: 48,
              left: 0,
            },
          }}
          onChange={onChange}
          onBlur={onBlur}
        >
          {options.map(({ value, label }) => (
            <S.MenuItem key={value} value={value}>
              {label}
            </S.MenuItem>
          ))}
        </S.Select>
      </S.FormControl>

      <FieldHelperText helperText={helperText} error={error} name={name} />
    </>
  )
}
